import type { ElevatedUser } from "@warrenio/api-spec/spec.oats.gen";

export const adminAdminUsersExample: ElevatedUser[] = [
    {
        custom_id: "111",
        created_at: 1570005812000,
        username: "test@dome.com",
        id: "f837d1ff-d614-4076-86ad-fa2ef2685337",
        role: "admin",
    },
    {
        custom_id: "222",
        created_at: 1537428563000,
        username: "demo@warren.com",
        id: "4cee0dab-0798-46cc-b514-050eec9fdfe6",
        role: "admin",
    },
    {
        custom_id: "333",
        created_at: 1540385454000,
        username: "jack@admin.com",
        id: "b087b4d4-0b17-4955-b282-09f5a181136f",
        role: "admin-accountant",
    },
    {
        custom_id: "444",
        created_at: 1623875805000,
        username: "user@admin.com",
        id: "132021ab-31c5-4f27-a7bc-1f8689f18d33",
        role: "admin",
    },
    {
        custom_id: "555",
        created_at: 1642600369000,
        username: "admin@warren.io",
        id: "8b462e37-ecd4-4945-9e28-fc2b0a38ce1c",
        role: "admin",
    },
];
